import { useQuery } from '@tanstack/react-query'

import { ClientStoredPaymentMethodsService } from '../services/client_stored_payment_methods.service'
import { ExternalStoredPaymentMethodClientDto } from '../types/api'
import { defaultQueryOptions } from './common'

export const useClientStoredPaymentMethods = (locationName: string) => {
  return useQuery<ExternalStoredPaymentMethodClientDto[]>({
    queryKey: ['clientStoredPaymentMethods', locationName],
    queryFn: () => ClientStoredPaymentMethodsService.list(locationName),
    ...defaultQueryOptions,
    enabled: !!locationName,
  })
}
